import { Table, TableContainer, useTheme } from '@mui/material'
import { Dispatch, Fragment, SetStateAction } from 'react'
import InvoiceEditTableHeader from './invoice-edit-table-header/invoice-edit-table-header'
import InvoiceEditTableBody from './invoice-edit-table-body/invoice-edit-table-body'
import InvoiceEditTableNotes from './invoice-edit-table-notes/invoice-edit-table-notes'
import { NotesContainer } from './invoice-edit-table.styles'
import { v4 as uuidv4 } from 'uuid'
import { InvoiceLineItem, InvoiceResponse } from 'store/invoices/invoices.types'
import InvoiceEditVieTax from 'pages/invoice/invoice-edit-view/invoice-edit-view-tax/invoice-edit-view-tax.component'
import FullWidthButton from 'components/full-width-button/full-width-button.component'

interface InvoiceEditTableProps {
  // lineItems: InvoiceLineItem[] | undefined
  invoice: InvoiceResponse | undefined
  lines: InvoiceLineItem[] | undefined
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
}

const InvoiceEditTable = ({
  invoice,
  lines,
  setLines,
}: InvoiceEditTableProps) => {
  const theme = useTheme()

  // const [lines, setLines] = useState<InvoiceLineItem[] | undefined>(lineItems)

  const handleAddLine = () => {
    setLines((prevLines) => {
      const currentLines = prevLines || []
      const lastLine = currentLines[currentLines.length - 1]

      return [
        ...currentLines,
        {
          id: uuidv4(),
          description: '',
          lineName: '',
          lineTotal: 0,
          position: lastLine ? lastLine.position + 1 : 1,
          quantity: 0,
          rate: 0,
          tax: true,
          taxAmount: 0,
          taxPercentage: 0,
        },
      ]
    })
  }

  return (
    <Fragment>
      {!!invoice?.lineItems && (
        <>
          <TableContainer
            className="hide-scrollbar"
            sx={{
              bgcolor: 'secondary.light',
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px',
            }}
          >
            <Table aria-label="invoice table">
              <InvoiceEditTableHeader />
              <InvoiceEditTableBody lines={lines || []} setLines={setLines} />
            </Table>
          </TableContainer>

          <NotesContainer theme={theme}>
            <FullWidthButton
              buttonText="+ Add a Line"
              handleAddLine={handleAddLine}
            />

            <div style={{ margin: '12px', marginTop: 100 }}>
              <InvoiceEditVieTax invoice={invoice} lines={lines || []} />
              <InvoiceEditTableNotes />
            </div>
          </NotesContainer>
        </>
      )}
    </Fragment>
  )
}

export default InvoiceEditTable
